<main>
  <section
    class="vehicleFinder"
    *ngIf="!redPlateSelected || searchRedPlateControl.value === ''"
  >
    <h5 class="vehicleFinder--title">{{ 'searchVehicle' | i18next }}</h5>
    <form [formGroup]="searchForm">
      <div class="vehicleFinder--container">
        <mat-form-field class="vehicleFinder--container__item">
          <!-- Búsqueda por Bastidor -->
          <mat-label for="vin" class="form--label">{{
            'vin' | i18next
          }}</mat-label>
          <input
            matInput
            type="text"
            class="form--input"
            name="vin"
            formControlName="vin"
            placeholder="{{ 'vin' | i18next }}"
          />
        </mat-form-field>

        <!-- Búsqueda por Matrícula -->
        <mat-form-field class="vehicleFinder--container__item">
          <mat-label for="plateNumber" class="form--label">{{
            'plateNumber' | i18next
          }}</mat-label>
          <input
            matInput
            type="text"
            class="form--input"
            name="plateNumber"
            formControlName="plateNumber"
            placeholder="{{ 'plateNumber' | i18next }}"
          />
        </mat-form-field>

        <!-- Botón de búsqueda -->
        <div class="vehicleFinder--container__item">
          <button
            type="button"
            class="vehicleFinder--container__item--button button-green"
            (click)="onSearch()"
            [disabled]="!vin && !plateNumber"
            [ngStyle]="
              !vin && !plateNumber
                ? { 'background-color': '#efffc1', 'font-weight': 'normal' }
                : { 'background-color': '#c8f546' }
            "
          >
            {{ 'btnSearch' | i18next | uppercase }}
          </button>
        </div>
      </div>
      <div class="error-message">
        <small *ngIf="searchError">
          {{ 'searchError' | i18next }}
        </small>
      </div>
      <div class="error-message">
        <small *ngIf="vinRepeat">
          {{ 'existingVehicle' | i18next }}
        </small>
      </div>
      <div class="error-message">
        <small *ngIf="inspectionReport">
          {{ 'duplicateError' | i18next }}
        </small>
      </div>
      <div
        class="vehicleFinder--container"
        *ngIf="requestType === requestTypeEnum.es"
      >
        <mat-form-field class="vehicleFinder--container__item">
          <!-- Matrícula del camión si selecciona más de 1 vehículo -->
          <mat-label for="truckPlateNumber" class="form--label">{{
            'truckPlateNumber' | i18next
          }}</mat-label>
          <input
            matInput
            type="text"
            class="form--input"
            name="truckPlateNumber"
            formControlName="truckPlateNumber"
          />
        </mat-form-field>
      </div>
    </form>
  </section>

  <section
    class="vehicleFinder"
    *ngIf="
      requestType === requestTypeEnum.es && vehicles && vehicles.length === 0
    "
  >
    <h5 class="vehicleFinder--title">{{ 'searchRedPlate' | i18next }}</h5>
    <form [formGroup]="searchRedPlateForm">
      <div class="vehicleFinder--container">
        <mat-form-field class="vehicleFinder--redPlateSearch">
          <!-- Búsqueda por placa roja -->
          <mat-label for="redPlate" class="form--label">{{
            'redPlate' | i18next
          }}</mat-label>
          <input
            matInput
            type="text"
            class="form--input"
            name="redPlate"
            formControlName="redPlate"
            [formControl]="searchRedPlateControl"
            [matAutocomplete]="auto"
          />
          <mat-autocomplete
            #auto="matAutocomplete"
            (optionSelected)="onOptionSelected($event)"
          >
            <mat-option
              *ngFor="let option of redPlates | async"
              [value]="option"
            >
              {{ option }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
        <div class="errorRedPlateContainer">
          <small class="error-message" *ngIf="redPlateError">{{
            'redPlateError' | i18next
          }}</small>
        </div>
        <div class="errorRedPlateContainer">
          <small class="error-message" *ngIf="noRedPlateError">{{
            'noRedPlateError' | i18next
          }}</small>
        </div>
      </div>
    </form>
  </section>

  <!-- Fieldset de resultados es -->
  <section
    class="vehicleFinder"
    *ngIf="
      requestType === requestTypeEnum.es && vehicles && vehicles.length > 0
    "
  >
    <h5 class="vehicleFinder--title">
      {{ 'infoVehicle' | i18next }}
    </h5>
    <div class="resultContainer">
      <div *ngFor="let vehicle of vehicles; let i = index" class="vehicle-item">
        <div class="resultContainer--header">
          <h4>{{ 'vehicle' | i18next }} {{ i + 1 }}</h4>
          <button
            type="button"
            class="btn btn-danger"
            (click)="removeVehicle(i)"
          >
            {{ 'delete' | i18next | uppercase }}
          </button>
        </div>
        <div class="resultContainer--details">
          <div class="resultContainer--details__section">
            <div class="resultContainer--details__section--item">
              <label class="resultContainer--details__label">{{
                'plateNumber' | i18next
              }}</label>
              <p>{{ vehicle.plateNumber || 'noData' | i18next }}</p>
            </div>
            <div class="resultContainer--details__section--item">
              <label class="resultContainer--details__label">{{
                'vin' | i18next
              }}</label>
              <p>{{ vehicle.vin }}</p>
            </div>
            <div class="resultContainer--details__section--item">
              <label class="resultContainer--details__label">{{
                'requestPccTMAIMG' | i18next
              }}</label>
              <p>{{ vehicle.tmaimg || 'noData' | i18next }}</p>
            </div>
            <div class="resultContainer--details__section--item">
              <label class="resultContainer--details__label">{{
                'model' | i18next
              }}</label>
              <p>
                {{ vehicle.model || 'noData' | i18next }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Fieldset de resultados sin es-->
  <section
    class="vehicleFinder"
    *ngIf="
      requestType !== requestTypeEnum.es && vehicles && vehicles.length > 0
    "
  >
    <h5 class="vehicleFinder--title">
      {{ 'infoVehiclePetitioner' | i18next }}
    </h5>
    <div class="resultContainer">
      <div *ngFor="let vehicle of vehicles; let i = index" class="vehicle-item">
        <div class="resultContainer--header">
          <h4>{{ 'vehicle' | i18next }} {{ i + 1 }}</h4>
          <button
            type="button"
            class="btn btn-danger"
            (click)="removeVehicle(i)"
          >
            {{ 'delete' | i18next | uppercase }}
          </button>
        </div>
        <div class="resultContainer--details">
          <div class="resultContainer--details__section">
            <div class="resultContainer--details__section--item">
              <label class="resultContainer--details__label">{{
                'plateNumber' | i18next
              }}</label>
              <p>{{ vehicle.vehicle.plateNumber }}</p>
            </div>
            <div class="resultContainer--details__section--item">
              <label class="resultContainer--details__label">{{
                'vin' | i18next
              }}</label>
              <p>{{ vehicle.vehicle.vin }}</p>
            </div>
            <div class="resultContainer--details__section--item">
              <label class="resultContainer--details__label">{{
                'summaryInsuranceType' | i18next
              }}</label>
              <p>{{ vehicle.insuranceType }}</p>
            </div>
            <div class="resultContainer--details__section--item">
              <label class="resultContainer--details__label">{{
                'requestPccTMAIMG' | i18next
              }}</label>
              <p>{{ vehicle.vehicle.tmaimg }}</p>
            </div>
            <div class="resultContainer--details__section--item">
              <label class="resultContainer--details__label">{{
                'model' | i18next
              }}</label>
              <p>
                {{ vehicle.vehicle.model || 'noData' | i18next }}
              </p>
            </div>
          </div>
          <div class="resultContainer--details__section">
            <div class="resultContainer--details__section--item">
              <label class="resultContainer--details__label">{{
                'requestType' | i18next
              }}</label>
              <p>{{ translate.translateRequestTypes(vehicle.requestType) }}</p>
            </div>
            <div class="resultContainer--details__section--item">
              <label class="resultContainer--details__label">{{
                'nis' | i18next
              }}</label>
              <p>{{ vehicle.user ? vehicle.user.nis : '-' }}</p>
            </div>
            <div class="resultContainer--details__section--item">
              <label class="resultContainer--details__label">{{
                'fullname' | i18next
              }}</label>
              <p>{{ vehicle.user ? vehicle.user.fullName : '-' }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <div class="btnContainer">
    <button
      [disabled]="
        (this.vehicles.length === 0 &&
          (!redPlateSelected ||
            redPlateSelected !== searchRedPlateControl.value)) ||
        (truckPlateRequired &&
          searchForm.get('truckPlateNumber')?.value === null)
      "
      class="btnContainer--btn btn confirm"
      matStepperNext
      mat-button
      (click)="nextStep()"
      [style]="
        (this.vehicles.length === 0 &&
          (!redPlateSelected ||
            redPlateSelected !== searchRedPlateControl.value)) ||
        (truckPlateRequired &&
          searchForm.get('truckPlateNumber')?.value === null)
          ? 'background-color: #565554'
          : 'background-color: #2c2a29'
      "
    >
      {{ 'btnContinue' | i18next | uppercase }}
    </button>
    <button
      class="btnContainer--btn btn cancel"
      [style]="'background-color: #2c2a29'"
      mat-button
      (click)="backStep()"
    >
      {{ 'btnReturn' | i18next | uppercase }}
    </button>
  </div>
</main>
